import React, { useCallback } from 'react';
import { Text } from '../Text/Text.es.js';
import { PeopleCard as PeopleCard$1, PeopleCardTitle, PeopleCardDescription, PeopleCardImageWrapper as PeopleCardImageWrapper$1, PeopleCardImage, FallbackWrapper } from './styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PeopleCardFallback = ({ fallback }) => /* @__PURE__ */ React.createElement(FallbackWrapper, null, /* @__PURE__ */ React.createElement(Text, {
  size: "jb",
  fontWeight: "bold"
}, fallback));
const PeopleCardImageWrapper = ({ fallback = "", size, src, alt }) => {
  const handleFallback = useCallback(() => /* @__PURE__ */ React.createElement(PeopleCardFallback, {
    fallback
  }), [fallback]);
  return /* @__PURE__ */ React.createElement(PeopleCardImageWrapper$1, {
    size
  }, /* @__PURE__ */ React.createElement(PeopleCardImage, {
    src,
    fallbackHandler: handleFallback,
    alt
  }));
};
const PeopleCard = (_a) => {
  var _b = _a, {
    children,
    src,
    alt,
    fallback,
    title,
    description,
    size = "md"
  } = _b, props = __objRest(_b, [
    "children",
    "src",
    "alt",
    "fallback",
    "title",
    "description",
    "size"
  ]);
  return /* @__PURE__ */ React.createElement(PeopleCard$1, __spreadValues({}, props), /* @__PURE__ */ React.createElement(PeopleCardImageWrapper, {
    size,
    fallback,
    src,
    alt
  }), title && /* @__PURE__ */ React.createElement(PeopleCardTitle, {
    size: "sm"
  }, title), description && /* @__PURE__ */ React.createElement(PeopleCardDescription, {
    size: "sm"
  }, description));
};
PeopleCard.displayName = "PeopleCard";

export { PeopleCard };
//# sourceMappingURL=PeopleCard.es.js.map
